import PlanSalesService from "@/api/services/planSales";
import { CLIENT_CANCELLATION_REASONS } from "@estaly/ui";

export default {
  namespaced: true,
  state: {},
  getters: {
    clientReasons: () => CLIENT_CANCELLATION_REASONS,
    fullContractCommitment: () => (plan) => {
      return plan?.cancellationPolicyType === "full_contract_commitment";
    },
    oneYearCommitment: () => (plan) => {
      return plan?.cancellationPolicyType === "one_year_commitment";
    },
  },
  mutations: {},
  actions: {
    async cancelPlan(_, { planFriendlyId, params }) {
      const { success } = await PlanSalesService.cancelPlan(planFriendlyId, params);
      return { success };
    },

    async scheduleCancellation(_, { params }) {
      const { success } = await PlanSalesService.scheduleCancellation(params);
      return { success };
    },
  },
};
